import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import EditCategoryModal from './EditCategory';
import EditSubcategoryModal from './EditSubcategory';
import EditFieldyModal from './EditField';
import DeleteCategoryModal from './DeleteCategory';
import DeleteSubcategoryModal from './DeleteSubcategory';
import DeleteFieldModal from './DeleteField';
import {
  MODAL_ADD_CATEGORY, MODAL_ADD_FIELD, MODAL_ADD_SUBCATEGORY,
  MODAL_DELETE_CATEGORY,
  MODAL_DELETE_FIELD,
  MODAL_DELETE_SUBCATEGORY,
  MODAL_EDIT_CATEGORY, MODAL_EDIT_FIELD, MODAL_EDIT_SUBCATEGORY,
} from '../../constants/modals';

const ModalsManager = ({ modal, onHide, onSubmit }) => {
  const modalsComponentsList = [
    {
      modalKey: MODAL_DELETE_CATEGORY,
      Component: DeleteCategoryModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: MODAL_DELETE_SUBCATEGORY,
      Component: DeleteSubcategoryModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: MODAL_DELETE_FIELD,
      Component: DeleteFieldModal,
      options: {
        bsSize: 'small',
        className: 'modal-confirm__wrapper',
      },
    },
    {
      modalKey: MODAL_ADD_CATEGORY,
      Component: EditCategoryModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: MODAL_EDIT_CATEGORY,
      Component: EditCategoryModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: MODAL_ADD_SUBCATEGORY,
      Component: EditSubcategoryModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: MODAL_EDIT_SUBCATEGORY,
      Component: EditSubcategoryModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: MODAL_ADD_FIELD,
      Component: EditFieldyModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
    {
      modalKey: MODAL_EDIT_FIELD,
      Component: EditFieldyModal,
      options: {
        bsSize: 'small',
        className: 'modal-md',
      },
    },
  ]
  if (modalsComponentsList.length) {
    return modalsComponentsList.map((item) => {
      const { Component, options } = item;
      const showModal = modal?.openModalKey === item.modalKey;

      return (
        <Modal
          key={`modal-${item.modalKey}`}
          show={showModal}
          backdrop="static"
          onHide={onHide}
          {...options}
        >
          <Component
            modalKey={item.modalKey}
            onHide={onHide}
            onSubmit={onSubmit}
            data={modal?.data}
          />
        </Modal>
      )
    })
  }
  return null;
}

ModalsManager.propTypes = {
  modal: PropTypes.object,
  open: PropTypes.string,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ModalsManager;
